export const ICON_MAP: Record<string, string> = {
  USDT: "/icons/usdt.svg",
  USDC: "/icons/usdc.svg",
  ETH: "/icons/eth.svg",
  TRX: "/images/tron.png",
};

export const NETWORK_ICON_MAP: Record<string, string> = {
  ERC20: "/icons/erc20.svg",
  TRC20: "/icons/trc20.png",
  ARB: "/images/arb.svg",
};
